export const validateMinLength = (password: string): boolean => {
  return password.length >= 8;
};

export const validateMaxLength = (password: string): boolean => {
  return password.length >= 8 && password.length <= 32;
};

export const validateHasUpperCaseLetter = (password: string): boolean => {
  return /[A-Z]/.test(password);
};

export const validateHasLowerCaseLetter = (password: string): boolean => {
  return /[a-z]/.test(password);
};

export const validateHasNumeral = (password: string): boolean => {
  return /[0-9]/.test(password);
};

export const validateHasSpecialCharacter = (password: string): boolean => {
  return /[^A-Za-z0-9]/.test(password);
};
export const validatePasswordStrength = (password: string): boolean => {
  return (
    validateMinLength(password) &&
    validateMaxLength(password) &&
    validateHasUpperCaseLetter(password) &&
    validateHasLowerCaseLetter(password) &&
    validateHasNumeral(password) &&
    validateHasSpecialCharacter(password)
  );
};

export const validatePasswordsMatch = (password?: string, passwordConfirm?: string): boolean => {
  return !!password && !!passwordConfirm && password === passwordConfirm;
};

/**
 * Validates a phone number based on common international formats.
 * Allows for:
 * - Country codes with + or 00 prefix
 * - Optional separators (space, dash, dot) with consistent use
 * - Reasonable length (8 to 15 digits total)
 *
 * @param phoneNumber The phone number to validate
 * @returns True if the phone number is valid, false otherwise
 */
export const validatePhoneNumber = (phoneNumber: string): boolean => {
  return (
    /^((\+|00)\d{1,3}[-. ]?)?(\d{1,4}[-. ]?){2,4}\d{1,4}$/.test(phoneNumber) &&
    phoneNumber.replace(/[-. ]/g, '').length >= 8 &&
    phoneNumber.replace(/[-. ]/g, '').length <= 15
  );
};

/**
 * Validates a country code phone number based on the following formats:
 * - "+49 12345678", // Germany
 * - "+1 1234567890", // USA/Canada
 * - "+44 1234567890", // UK
 * - "0049 12345678", // Germany
 * - "001 1234567890", // USA/Canada
 * - "0044 1234567890" // UK
 * @param phoneNumber The phone number to validate
 * @returns True if the phone number is valid, false otherwise
 */
export const validateCountryCodePhoneNumber = (phoneNumber: string): boolean => {
  return /^(?:\+|00)\d{1,3}/.test(phoneNumber);
};

export const validateEmail = (email?: string): boolean => {
  return !!email && /\S+@\S+\.\S+/.test(email);
};
